export default "__VITE_ASSET__JUKH5SSY__"